module.exports = __webpack_public_path__ + "img/976006558.a0169197.jpg";